(() => {
  'use strict';
  const source = document.currentScript?.dataset.toolsSrc;
  const tools = document.querySelector('occhio-frame-tools');
  if (!source || !tools || customElements.get('occhio-frame-tools')) return;
  const controller = new AbortController();
  let pending, observer;
  const expose = root => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.('[data-occhio-compare]')) root.hidden = false;
    root.querySelectorAll('[data-occhio-compare]').forEach(button => {button.hidden=false;});
  };
  const load = () => {
    if (customElements.get('occhio-frame-tools')) return Promise.resolve();
    if (pending) return pending;
    pending = new Promise((resolve,reject) => {
      const script=document.createElement('script');script.src=source;script.async=true;
      script.onload=() => {
        if (!customElements.get('occhio-frame-tools')) {pending=null;reject(new Error('Frame tools unavailable'));return;}
        controller.abort();observer?.disconnect();resolve();
      };
      script.onerror=() => {script.remove();pending=null;reject(new Error('Frame tools unavailable'));};
      document.head.append(script);
    });
    return pending;
  };
  const intent = event => {
    if (event.target.closest('[data-occhio-compare], [data-compare-entry]')) load().catch(()=>{});
  };
  document.addEventListener('pointerover',intent,{signal:controller.signal,passive:true});
  document.addEventListener('focusin',intent,{signal:controller.signal});
  document.addEventListener('click',event => {
    const button=event.target.closest('[data-occhio-compare]');
    if (!button || customElements.get('occhio-frame-tools')) return;
    event.preventDefault();event.stopPropagation();button.disabled=true;
    load().then(()=> {button.disabled=false;if (button.isConnected) button.click();}).catch(()=> {
      button.disabled=false;
      try {tools.querySelector('[data-compare-status]').textContent=JSON.parse(tools.querySelector('[data-occhio-tool-strings]').textContent).error;} catch (_) {}
    });
  },{capture:true,signal:controller.signal});
  expose(document);
  observer=new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) {
      if (node.matches('occhio-frame-finder') || node.querySelector('occhio-frame-finder')) load().catch(()=>{});
      expose(node);
    }
  });
  observer.observe(document.body,{childList:true,subtree:true});
  let restore=false;
  try {
    const key=['occhio-compare-v1',tools.dataset.root,tools.dataset.currency,tools.dataset.country].join(':');
    const handles=JSON.parse(sessionStorage.getItem(key)||'[]');
    restore=(Array.isArray(handles) && handles.length>0) || Boolean(localStorage.getItem('occhio-selection-v1'));
  } catch (_) {}
  if (restore || document.querySelector('occhio-frame-finder')) load().catch(()=>{});
})();
